import React from "react";
import "./Group682.css";

function Group682(props) {
  const { className } = props;

  return (
    <div className={`group-68-2 ${className || ""}`}>
      <img className="icon-label-3" src="/img/path-55-1@1x.png" />
      <div className="redeem-2 avenir-heavy-normal-eerie-black-7px">redeem</div>
    </div>
  );
}

export default Group682;
